import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TooltipPackageInfo from '../../Tooltip/TooltipPackageInfo';
import EpiContext from '@episerver/spa-core/Spa';


const EnergyPackage = (props) => {
  const [description, setDescription] = useState('');
  const displayProductStatus = props.selectedSubscriber?.productStatus != 'Active' && props.selectedSubscriber?.productStatus != 'INS' && props.selectedSubscriber?.productStatus != 'A';


  useEffect(() => {
    if (props.isFetchData && props.selectedSub) {
      const plan = props.iContent.planDescriptionByCode.value?.filter((el) => el.code === props.selectedSub?.pricePlanCode);
      if (plan) {
        setDescription(plan[0]?.description);
      }
    }
  }, [props.isFetchData, props.selectedSub]);

  return (
    <div className='selfcare-package'>
      {props.isFetchData ?
        <div className='selfcare-package-wrapper'>
          <Image className='package-image' src={EpiContext.getEpiserverUrl(props.packageImage)} alt='tv' />
          <div className='content'>
            <div className='header'>
              <div>
                <div className='title'>
                  {props.selectedSub.packageName}
                </div>
                {description &&
                  <span className='package-description'>{description}</span>
                }
              </div>
              <div className='package-info'>
                <TooltipPackageInfo position={'right'} />
              </div>
            </div>
          </div>
        </div> :
        <div style={{ display: 'flex', flex: '1', flexDirection: 'column', gap: '1px', width: '100%', height: '100%' }}>
          <Skeleton height={145} animation="wave" />
          <Skeleton height={72} animation="wave" />
          <Skeleton height={43} animation="wave" />
        </div>
      }
    </div >
  )
}

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication?.loginData?.isFullAuthenticated,
    isPrivate: state.authentication?.loginData?.userDetails?.isPrivate,
    selectedSub: state.selfcarePage?.selectedSubscriber,
    subscribers: state.selfcarePage?.subscribersByProduct,
    isFetchData: state.selfcarePage?.isFetchData,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EnergyPackage);

